import React from "react";
import { StaticImage } from "gatsby-plugin-image";

const EmojiIcons = () => {
  return (
    <div className="icons">
      <div className="icon">
        <StaticImage
          src={"../../../../../assets/images/withdraw/smiley.png"}
          alt="Smiley"
          placeholder="blurred"
          width={32}
          quality={100}
        />
      </div>
      <div className="icon">
        <StaticImage
          src={"../../../../../assets/images/withdraw/crazy.png"}
          alt="Crazy"
          placeholder="blurred"
          width={32}
          quality={100}
        />
      </div>
      <div className="icon">
        <StaticImage
          src={"../../../../../assets/images/withdraw/cowboy.png"}
          alt="Cowboy"
          placeholder="blurred"
          width={32}
          quality={100}
        />
      </div>
      <div className="icon">
        <StaticImage
          src={"../../../../../assets/images/withdraw/devil.png"}
          alt="Devil"
          placeholder="blurred"
          width={32}
          quality={100}
        />
      </div>
      <div className="icon">
        <StaticImage
          src={"../../../../../assets/images/withdraw/love.png"}
          alt="Love"
          placeholder="blurred"
          width={32}
          quality={100}
        />
      </div>
    </div>
  );
}

export default EmojiIcons;
